<template>

  <div>
    <creating
      v-if="!dataChart && loading"
      height="320px" />
    <div v-if="dataChart">
      <!--<div>{{ chartType }}</div>-->

      <div v-if="chartType === 'columns'">
        <Columns
          :dataChart="dataChart"
          @expand="expand"
          :disableExpandDetails="disableExpandDetails" />
      </div>

      <div v-if="chartType === 'columnsHistory'">
        <ColumnsHistory
          :dataChart="dataChart"
          @expand="expand" />
      </div>
      
      <div v-if="chartType === 'columnsWithSegments'">
        <ColumnsWithSegments
          :dataChart="dataChart"
          @expand="expand"
          :disableExpandDetails="disableExpandDetails" />
      </div>

      <div v-if="chartType === 'pipelineConversion'">
        <CustomPipelineConversion
          :dataChart="dataChart"
          @expand="expand" />
      </div>

      <div v-if="chartType === 'columnsWithSegmentsGlobalPercent'">
        <ColumnsWithSegmentsGlobalPercent
          :dataChart="dataChart"
          @expand="expand" />
      </div>

      <div v-if="chartType === 'columnsWithSegmentsHistory'">
        <ColumnsWithSegmentsHistory
          :dataChart="dataChart"
          @expand="expand" />
      </div>
      
      <div v-if="chartType === 'pizza'">
        <Pizza
          :dataChart="dataChart"
          @expand="expand" />
      </div>
      
      <div v-if="chartType === 'summary'">
        <Summary
          :dataChart="dataChart"
          @expand="expand" />
      </div>
      
      <div v-if="chartType === 'table'">
        <Table
          :dataChart="dataChart"
          :page="page"
          :sortBy="sortBy"
          :sortDirection="sortDirection"
          @sort="sort"
          @changePage="changePage"
          :exportModule="dashcomponent.module"
          :exportSelect="dashcomponent.select"
          :exportFilters="allFilters"
          />
      </div>

      <Expand
        v-if="expandData"
        :dashcomponent="dashcomponent"
        :filters="expandData.filters"
        :title="expandData.name"
        @hideModal="expandData = null" />
      <!--<pre>{{ dataChart }}</pre>-->
    </div>
  </div>

</template>

<script>
import Columns from './Columns'
import ColumnsWithSegments from './ColumnsWithSegments'
import ColumnsWithSegmentsGlobalPercent from './ColumnsWithSegmentsGlobalPercent'
import ColumnsHistory from './ColumnsHistory'
import ColumnsWithSegmentsHistory from './ColumnsWithSegmentsHistory'
import Pizza from './Pizza'
import Summary from './Summary'
import Table from './Table'
import CustomPipelineConversion from './CustomPipelineConversion'
import Expand from './Expand'

export default {
  name: 'ReportChart',
  components: {
    Columns,
    ColumnsWithSegments,
    ColumnsWithSegmentsGlobalPercent,
    ColumnsHistory,
    ColumnsWithSegmentsHistory,
    Pizza,
    Summary,
    Table,
    Expand,
    CustomPipelineConversion
  },
  props: {
    disableGlobalFilters: {
      type: Boolean,
      default: false
    },
    dashcomponent: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dataChart: null,
      page: null,
      sortBy: null,
      sortDirection: null,
      expandData: null
    }
  },
  computed: {
    disableExpandDetails () {
      return this.dashcomponent.disable_expand_details
    },
    chartType () {
      if (
        this.dashcomponent.type === 'columns' &&
        this.dashcomponent.module === 'moves' &&
        this.dashcomponent.group_by === 'stage_id' &&
        this.dashcomponent.segment_by === 'moved' &&
        this.dashcomponent.metric === 'count_items'
      ) {
        return 'pipelineConversion'
      }
      // if (
      //   this.dashcomponent.type === 'columns' &&
      //   this.dashcomponent.module === 'diversity' &&
      //   this.dashcomponent.group_by === 'stage_id' &&
      //   this.dashcomponent.metric === 'count_items'
      // ) {
      //   return 'columnsWithSegmentsGlobalPercent'
      // }
      return this.dataChart.type
    },
    reportingFilters () {
      return this.$store.getters.getReportingFilters
    },
    allFilters () {
      const dashcomponentFilters = this.dashcomponent.filters || []
      const dateRangeField = this.dashcomponent.date_range
      console.log(this.dashcomponent)

      return !this.reportingFilters || this.disableGlobalFilters ? dashcomponentFilters : [
        ...dashcomponentFilters,
        ...(this.reportingFilters.date ? [{
          'field': dateRangeField,
          'conditional': 'date_more_than',
          'value_str': this.reportingFilters.date ? this.reportingFilters.date[0] : undefined
        },
        {
          'field': dateRangeField,
          'conditional': 'date_less_than',
          'value_str': this.reportingFilters.date ? this.reportingFilters.date[1] : undefined
        }] : []),
        ...(this.reportingFilters.global_company_id ? [{
          'field': 'global_company_id',
          'conditional': 'terms',
          'values': [this.reportingFilters.global_company_id]
        }] : []),
        ...(this.reportingFilters.global_departament_id ? [{
          'field': 'global_departament_id',
          'conditional': 'terms',
          'values': [this.reportingFilters.global_departament_id]
        }] : [])
        // ...(this.reportingFilters.global_user_id ? [{
        //   'field': 'global_user_id',
        //   'conditional': 'terms',
        //   'values': [this.reportingFilters.global_user_id]
        // }] : [])
      ]
    }
  },
  watch: {
    dashcomponent: {
      deep: true,
      handler: function (newValue) {
        this.loadData()
      }
    },
    reportingFilters () {
      this.loadData()
    }
  },
  created () {
    if (this.dashcomponent) {
      this.loadData()
    }
  },
  methods: {
    loadData () {
      console.log(this.allFilters)

      this.axios.post('/accounts/' + this.$store.getters.getAccount._id + '/reporting', {
        ...this.dashcomponent,
        page: this.page,
        sort_by: this.sortBy,
        sort_direction: this.sortDirection,
        filters: this.allFilters
      }).then(result => {
        if (result.data) {
          this.dataChart = result.data
        }
      })
    },
    changePage (n) {
      this.page = n
      this.loadData()
    },
    sort (params) {
      this.sortBy = params.sortBy
      this.sortDirection = params.sortDirection
      this.loadData()
    },
    expand (data) {
      this.expandData = {
        ...data,
        filters: [...this.allFilters, ...data.filters]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/index.vue